import { Component, input, output, inject, LOCALE_ID } from '@angular/core';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AttributeListItem,
  ProductAttributeValueResponse,
} from '../../../../../../services/productAttributes/productAttributes.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-attributes-table',
  standalone: true,
  imports: [DragDropModule, NgClass],
  templateUrl: './attributes-table.html',
    styleUrl: './attributes-table.scss',
})
export class AttributesTable {
  private locale = inject(LOCALE_ID);

  productType = input<'create' | 'edit'>('create');

  attributes = input.required<AttributeListItem[]>();

  onDrop = output<AttributeListItem[]>();
  onAddValue = output<number>();
  onEditValue = output<{ attrIdx: number; valIdx: number }>();
  onDeleteValue = output<{ attrIdx: number; valIdx: number }>();
  onRemove = output<number>();
  onEditAttr = output<number>();

  get isArabic(): boolean {
    return this.locale.startsWith('ar');
  }

  getAttrTitle(attr: AttributeListItem): string {
    return this.isArabic
      ? attr.attributeKey.titleAr || attr.attributeKey.titleEn || ''
      : attr.attributeKey.titleEn || '';
  }

  getValTitle(val: ProductAttributeValueResponse): string {
    return this.isArabic ? val.titleAr || val.titleEn || '' : val.titleEn || '';
  }

  handleDrop(event: CdkDragDrop<AttributeListItem[]>) {
    const updatedList = [...this.attributes()];
    moveItemInArray(updatedList, event.previousIndex, event.currentIndex);
    this.onDrop.emit(updatedList);
  }
}
